import { Component } from '@angular/core';
import { PoHeader } from 'app/model/entities/entity-model';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { SplitPurchaseOrdersDialogParams } from './split-purchase-orders-dialog.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from 'app/shared/domain.service';

export interface EditPoInstructionsDialogParams extends DialogParams {
  poHeader: PoHeader;
}

@Component({
    templateUrl: './edit-po-instructions-dialog.component.html',
    standalone: false
})
export class EditPoInstructionsDialogComponent extends DialogBaseComponent<EditPoInstructionsDialogParams>  {
  poHeader: PoHeader;
  
constructor( public config: DynamicDialogConfig<SplitPurchaseOrdersDialogParams>, public dialogRef: DynamicDialogRef, public domainService: DomainService) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Purchase Order Instructions",
      width: '800px',
      height: '430px',
    })
    this.poHeader = this.params.poHeader;
    this.isPageReady = true;
  }

  async save() {
    if (this.poHeader.entityAspect.entityState.isUnchanged()) {
      return false;
    }
    await this.dbSaveService.saveChanges();
    this.dialogRef.close(true);
  }

  cancel() {
    this.uow.rollback();
    this.dialogRef.close(false);
  }

}
